<template>
    <u-tab-button v-bind="$attrs">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-tab-button>
</template>

<script>
import UTabButton from "@/components/publish/styles/tabs/u-tab-button.vue";

export default {
    props: {},
    components: {
        UTabButton,
    },
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
